import { render, staticRenderFns } from "./wxUser.vue?vue&type=template&id=02d3a2f8&scoped=true"
import script from "./wxUser.vue?vue&type=script&lang=js"
export * from "./wxUser.vue?vue&type=script&lang=js"
import style0 from "./wxUser.vue?vue&type=style&index=0&id=02d3a2f8&prod&lang=scss&scoped=true"
import style1 from "./wxUser.vue?vue&type=style&index=1&id=02d3a2f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.96.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d3a2f8",
  null
  
)

export default component.exports